//外部组件引入
import React, {Component, Fragment} from 'react';
import {Flex, Button, PullToRefresh, List, Badge,Toast,Modal} from 'antd-mobile';
import {inject, observer} from 'mobx-react';
import EnrollServers from '../../services/EnrollServers';
//自定义内容引入
import UserList from "./userList";
import Config from "../../config";
import WxApi from "../../common/wxapi";
import { getRandomLotteryBanner } from "../../common/lotteryBanner";
import { withAppBasename } from "../../common/router";
import { updateAllSeo } from '../../common/seo';
import NewMsgDialog from '../../components/NewMsgDialog';
import SetUserInfo from '../../components/SetUserInfo';
import ManageDialog from '../../components/ManageDialog';
import DeleteEnrollDialog from '../../components/DeleteEnrollDialog';
import VocherModal from '../../components/VocherModal';
//图片引入
import img_see from "../../res/img/group_only.png";
import img_pintuan from "../../res/img/ic_pintuan_time.png";
import img_identification_p from "../../res/img/ic_identification_person_small.png";//个人
import img_identification_c from "../../res/img/ic_identification_company_small.png";//企业
import img_identification_g from "../../res/img/ic_identification_gzh_small.png";//公众号
import wxapi from "../../common/wxapi";
// import img_wechat_com from "../../res/img/ic_detail_wechat.png";
// import img_phone_com from "../../res/img/ic_detail_phone.png";
import img_qun from "../../res/img/ic_detail_group_photo.png"
import img_arrow_down from "../../res/img/ic_arrow_up.png";
import img_code_home from "../../res/img/ic_code_homepage.png";
import img_mask_arrow from "../../res/img/ic_mask_arrow.png";
import img_pintuan_tips from "../../res/img/pic_pintuan.png";
import right_arrow from "../../res/img/right_arrow.png";
import ic_bar_create from "../../res/img/ic_bar_create.png";
import ic_person_identity from "../../res/img/ic_person_identity_V.png";
import is_follow from "../../res/img/ic_detail_follow_done.png";
import no_follow from "../../res/img/ic_detail_follow.png";
import img_subscription from "../../res/img/ic_detail_notice_guide.png"
import left_arrow from "../../res/img/icon_left_arrow.png";

import ic_top_row from "../../res/img/ic_detail_top_arrow.png"
import ic_top_notice from "../../res/img/ic_detail_top_notice.png"
import ic_conct_btn from "../../res/img/ic_conct_btn.png"
import icon_right_img from '../../res/img/right_arrow_blue.png'
import icon_create_enroll from '../../res/img/icon_create_enroll.png'
import icon_adress from '../../res/img/icon_adress.png'
import icon_video_img from '../../res/img/big-num-video.png'
import icon_close_img from '../../res/img/ic_popup_close.png'
import SubmitNotice from '../../components/SubmitNotice';
const Item = List.Item;
const Brief = Item.Brief;


@inject("enrollStore", "loadingStore", "myEnrollStore", "authStore")
@observer
class App extends Component {

    state = {
        height: 0,
        lotteryBanner: getRandomLotteryBanner(),
        sharePanel:'none',//分享选择界面
		showDetailQrCode:'none',
		showHomePageQrCode:'none',
		shareFriend:'none',
		tokenPanel:'none',//口令输入框
		heightAuto:false,//图片是否根据高度自适应
		rendBanner:true,
		isWeixin:true,//判断是否在微信环境
		hasActive:true,//这个活动是否存在
		img_code_home:'',
		loginTimer:'',
		groupDialog:false,
		btnTypeText:["立即报名", "点击填写", "立即预约", "了解更多", "下一步","立即购买",'立即申请','立即购买'],
		showWxlink:false,
		censorModal:false,
		showEnrollToken:false,
		enroll_token:'',
		groupList: [],
		show_notice: false,
		vipList: [],
		isVertical: false,
		showManage: false,
		showVoucher: false,
		deleteDialogShow: false,
		timeInfo: {
			hour: 0,
			minute: 0,
			second: 0,
		}
    };

	renderHeader(detail) {
		const miniBtnStyle = {
			width: 'calc(100vw - 65px)',
		    height:'40px',
		    background:'#f7f7f7',
			color: '#666666',
			fontSize:12,
			textAlign:'center',
		   }

		let signName = detail.sign_name;
		if(detail.auth == 1 && !detail.cert_show){
			signName = detail.sign_name.substr(0,1) + "**";
		}

		return(<div className="d-header">
			<a className="d-header-my" href={withAppBasename('/manage/myEnroll')} onClick={()=>{
				this.props.enrollStore.getCurrMenu(2)
				window._hmt.push(['_trackPageview',  '/manage/myEnroll'])
			}}>
				<img className="left-arrow" src={left_arrow} />
				<span>我的</span>
			</a>
			<div className="d-header-left cursor" onClick={()=>{
				window._hmt.push(['_trackEvent', 'button_to_wx','', '活动详情顶部点击打开小程序按钮', '']); //百度统计
				if((!WxApi.isMobile() || WxApi.isOtherEnvironments()) && !WxApi.isWeixn()){ //pc浏览器					
					this.showDetailQrCode('block')
				}else if(WxApi.isWeixn() && !Config.TOKEN){
					React.$wx.webLogin();
				}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){//手机浏览器				
					this.getTicket(detail)
				}else if(WxApi.isWeixn() && !WxApi.isMobile()){
					this.props.history.push('/h/'+ detail.owner_unionid)
				}	
			}}>
				<img src={detail.owner_pic||Config.defaultAvatar} />
				<h4 className="user-name">{signName}</h4>	
				<button className="btn-open-mini" style={{backgroundColor: this.state.themColor}}>去看看</button>
			</div>
			{
				WxApi.isWeixn() && WxApi.isMobile() ? <div className="btn-open-mini-opacity">
					<wx-open-launch-weapp
						style={miniBtnStyle}
						id="launch-btn"
						username="gh_ae6449501a82"
						path={detail.eid ? this.wxJumpPath : '/pages/default/default.html'}
						>
						<script type="text/wxtag-template">
							<div style={miniBtnStyle}>
								<div>去看看</div>
							</div>
						</script>
					</wx-open-launch-weapp>
				</div> : ''
			}
			</div>);
	}

    getDetail() {
        if (Config.EID) {

            let _this = this;
            this.props.enrollStore.getGroupDetailByEid().then(async (res) => {
                let {detail} = _this.props.enrollStore;
				// share=2 的小程序卡片仅限发起人和管理员，H5 转发入口统一展示无权限页。
				const isOwnerOrAdmin = Number(detail.is_owner) === 1 || Number(detail.is_admin) === 1 || Number(detail.admin1) === 1 || Number(detail.admin3) === 1 || (detail.admins_node && detail.admins_node.length > 0);
				if(Number(detail.share) === 2 && !isOwnerOrAdmin){
					_this.props.history.replace('/error/6');
					return;
				}
				detail.owner_pic = await wxapi.checkImage(detail.owner_pic);			 
				let themColor = '#00a8f3';
				if(detail && detail.btn_config && detail.btn_config.color){
					themColor = detail.btn_config.color;
				}		 
				let vipList = [];
				if(detail.user_owner_vip_all && detail.user_owner_vip_all.length){
					vipList = detail.user_owner_vip_all.filter(vip => vip.expire > new Date().getTime() / 1000).map(vip => vip.card_id); //获取当前用户有哪些没过期的会员卡
				}
				_this.setState({
					sub_user: detail.sub_user,
					detail: detail,
					hasActive:res.data.sta == -1?false:true,
					themColor,
					vipList: vipList,
				})
                
                //订阅消息回调
				let sceneId = WxApi.getQueryString("scene");
				let openid = WxApi.getQueryString("openid");
				let notice = sessionStorage.getItem("notice");
				if(sceneId && openid && notice =='notice'){
					_this.receiveNotice(sceneId,openid)
				}
                		
				if(detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2)){ //开启了倒计时
					this.getTimeDown(detail);
				}

				if(detail.sub_user_setting && detail.sub_user_setting.indexOf('group_enter') != -1){ //指定群聊可参与		
					if((detail.is_owner || detail.admin3 == 1)){
						this.initShareGroup(detail);
					}else if(!detail.info_id){
						this.props.history.push('/error/5')
					}
				}
				  				 
                if(detail.title){
					document.title = detail.title
					updateAllSeo(detail)
	                sessionStorage.setItem("authorizer_appid",detail.authorizer_appid);
	                if(!Config.TOKEN){
						let isWeixin = WxApi.isWeixn();
						let isMobile = WxApi.isMobile();
						const code = WxApi.getQueryString("code");
						const isOldUser = localStorage.getItem('isOldUser'); //微信曾经授权过报名工具的用户
						if(!isWeixin){
							_this.setState({
								isWeixin:isWeixin,
								isMobile:isMobile
							})
						}else if(code || isOldUser){//微信收授权后，则重新登录
							WxApi.jumpWxAuth(() => {
								_this.getDetail();
							}, { auto: true });
						}
	                }else{
						_this.getNoticeInfo(detail);  //顶部展示通知	
	                }
                }
                
                if(detail.unionid){
                	sessionStorage.setItem('unionid',detail.unionid);
					sessionStorage.setItem('owner_unionid',detail.owner_unionid);
                }
       
                
                let shareText = "";
				if(detail.auth > 1){
					shareText = detail.sign_name;
				}else if(detail.auth == 1){
					shareText = "<点击查看内容>"
				}else{
					shareText = "来自报名工具小程序"
				}
				
				if(detail.content && Array.isArray(detail.content)){
					let index = detail.content.findIndex(item=>item.type === 'text'&&item.value)
					if(index>-1){
						shareText = detail.content[index].value
					}
				}
				await this.toEditorMsg(detail)
				this.wxJumpPath = `/groupbuy/pages/groupbuy/detail.html?eid=${detail.eid }&referer=${Config.referer}`
                let _url = wxapi.replaceParamVal('referer',Config.referer) + "/group";
				wxapi.setShare(detail.title, shareText, _url, detail.banner || Config.LOGO);
				/*
				 * Non-VIP initiators are allowed to access the group detail page.
				if(detail.auth == 0){
					if(wxapi.isWeixn()){ //这个是为了避免在ios中注册微信api与初始进入页面不一致，导致微信api不生效
						const checkWxApi = () => {
							return new Promise((resolve, reject) => {
							  let interval = setInterval(() => {
								if (typeof window.wx !== 'undefined' && window.wx && window.wx.openBusinessView) {
									clearInterval(interval);
									resolve();
								}
							  }, 200);
							});
						  }						  
						checkWxApi().then(() => {
							this.props.history.replace('/share?eid='+detail.eid+'&referer='+Config.referer);
						});
					}else{
						this.props.history.replace('/share?eid='+detail.eid+'&referer='+Config.referer);	
					}	
				}
				*/
				if(detail.censor_status==2){
                    this.props.history.push('/error/2')
                }else if(detail.censor_status == 3){
					this.setState({ censorModal: true });			 
				}
				if(localStorage.getItem('cert_eid') == detail.eid){
					localStorage.removeItem('cert_eid');
					this.setState({showVoucher: true});
				}
				if(detail.banner){
					//根据短边来裁剪banner图片
					let _img  = new Image();
					_img.src = detail.banner;
					_img.onload = function(detail){					 
						if(_img.height >= _img.width * 1.5){
							_this.setState({isVertical: true});
						}				 
					}
					_img.onerror = function(err){
						detail.banner = null;
					}
				}else{
					detail.banner = '';
				}				
            }, () => {
                this.props.history.push('/page-404')
            });
            this.props.enrollStore.restUserListPage('group');

        }
        else {
            this.props.history.push('/page-404')
        }

    }
	// 如果是发起人编辑参与者报名信息，则直接跳转
	toEditorMsg(detail){
		if(!detail || !detail.title)return
		return new Promise((resolve, reject)=>{
			let info_id = WxApi.getQueryString('info_id')
			let verified = WxApi.getQueryString('verified')
			let token = WxApi.getQueryString("tk")
			if(info_id && verified){		
				if(token && !WxApi.isWeixn()){
					localStorage.setItem(Config.wx_token_key,token)			
				}	
				sessionStorage.setItem('fromPC',1)//从pc过来编辑报名信息			
				this.props.enrollStore.getItemData().then(()=>{					
					this.props.myEnrollStore.setCurrentEnroll({info_id,verified});
					const d = this.props.enrollStore.detail || detail;
					if (verified == 4) {
						// 待支付 → 锁单页（团购带 is_group=1, temp=6, tid）
						const tid = (d.team_info && d.team_info.tid) ? d.team_info.tid : '';
						this.props.history.push({
							pathname: '/enrollLock',
							search: 'info_id=' + info_id + '&eid=' + (Config.EID || d.eid || '') + '&temp=6&verify=' + (d.verify || 0) + '&auth=' + (d.auth || 0) + '&is_group=1' + (tid ? '&tid='+tid : '')
						});
						reject();
					} else {
						this.props.history.push('/enrollGroupForm?eid='+ Config.EID);
						reject();
					}
				})					
			}else if(WxApi.getQueryString('eid') && WxApi.getQueryString('id')){ //打印pdf上的二维码扫描进入这里	
				info_id = WxApi.getQueryString('id')	 
				if(Config.TOKEN){
					this.props.enrollStore.getItemData().then(()=>{					
						this.props.myEnrollStore.setCurrentEnroll({info_id})
						this.props.history.push('/enrollGroupForm?eid='+ Config.EID)
						reject()
					})		
				}else{
					React.$wx.webLogin();
				}							
			}else{
				resolve()
			}		
		})
		
	}
    // 从普通浏览器跳转到微信小程序
	getTicket(detail){
		this.props.myEnrollStore.getShortTicket({eid:detail.eid, referer: Config.referer}).then(res=>{
			if(res.sta == 0){
				window.location.href = res.data.scheme_ticket;
			}
		})
	}
    initShareGroup(detail){
		this.props.myEnrollStore.getShareGroup(detail.eid).then(res=>{
			if(res.sta == 0){				 
				this.setState({groupList: res.data.open_group});
			}
		})		
	}
    //订阅通知
	receiveNotice(sceneId,openid){
		this.props.myEnrollStore.subNotice(sceneId,openid).then(() => {
			let {orderStatus} = this.props.myEnrollStore;
			if(orderStatus){
				sessionStorage.removeItem("notice");
				Toast.success('订阅成功!', 1);
			}
		});
	}
	
	//获取微信系统通知信息
	getNoticeInfo(detail){
		let _this = this;
		if(Config.TOKEN){
			this.props.myEnrollStore.getNoticeAll(detail.eid).then(() => {
				_this.renderNotice(detail)
				//对齐小程序 detailnotice follow 分支：权限项为 info_id/on_behalf/is_owner/is_admin/sup_vip，发起人/管理员未报名也可见
				let followPerm = this.canShowSubmitNotice(detail) || detail.on_behalf == 1;
				let showScene = (detail.follow.scene == 0 && followPerm) || (detail.follow.scene == 1 && detail.verify == 1 && detail.verified == 1) || (detail.follow.scene == 2 && followPerm || (detail.verify ==1 && detail.verified == -1));
				const {wxNotice} = this.props.myEnrollStore;
				let noticeArr = wxNotice.msg_list;
				let sms_list = wxNotice.sms_list;
				if(noticeArr && noticeArr.length > 0){
					noticeArr = noticeArr.filter(item => !item.time_out || item.time_out == 0);
				}
				let show_notice = false;
				if(noticeArr && noticeArr.length > 0 &&  noticeArr[0].content && this.canShowSubmitNotice(detail)){
					show_notice = true;
				}else if(sms_list && sms_list.length > 0){
					show_notice = true;
				}else if(detail && detail.follow && detail.follow.type > 0 && (detail.follow.desc||detail.follow.qrcode||detail.follow.link_url) && showScene){
					show_notice = true;
				}
				this.setState({show_notice});
			});
		}
	}

    componentDidMount() {
        this.getDetail();
		if (Config.TOKEN) {
			this.props.enrollStore.getUserInfo().catch(() => {});
		}
		sessionStorage.removeItem('teamReqList');
		sessionStorage.removeItem('teamPersonalMsg');	
		this.props.enrollStore.getShare(1).then((d) => { //右侧广告码
			if(d && d.url) {
				this.setState({
					detailQrCode: d.url,
				})
				this.props.myEnrollStore.setShareImg(d.url);
			}
		})		 
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.url !== nextProps.match.url) {
            this.getDetail();
        }
    }

	// 右侧广告位
	renderWxCode(){
		if(this.state.detailQrCode){
			return (
				<div className="advert-box-right">
					<div className="wx-code-box">
						<div className="wx-qrcode">
							<img src={this.state.detailQrCode}></img>
						</div>
						<span>微信扫一扫</span>
						<span className="wx-watch">打开小程序</span>
					</div>
					<a className="create-enroll-box" target="_blank" href='https://www.baominggongju.com/?hmsr=h5'>
						<img src={icon_create_enroll} className="icon-create"/>
						<span className="enroll-text">我也要创建活动</span>	
						<img src={icon_right_img} className="icon-right-blue"/>
					</a>					
				</div>
			)
		}
	}
	// 指定群参加
	renderWxGroup(detail){
		const miniBtnStyle = {
			position: 'absolute',
			left: 0,
			top: 0,
			width: '100%',
			height: '40px',
		}
		return (
			<div class='fixed-group-team' style={{bottom: this.state.show_notice ? '90px' : '50px'}}>
				<div className='group-main' onClick={()=>{
					window._hmt.push(['_trackEvent', 'button_to_wx','', '活动详情顶部点击打开小程序按钮', '']); //百度统计				 
					if((!WxApi.isMobile() || WxApi.isOtherEnvironments()) && !WxApi.isWeixn()){ //pc浏览器							 	
						this.showDetailQrCode('block')
					}else if(WxApi.isWeixn() && !Config.TOKEN){					 
						React.$wx.webLogin();
					}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){//手机浏览器							 
						this.getTicket(detail)
					}else if(WxApi.isWeixn() && !WxApi.isMobile()){					 
						this.props.history.push('/h/'+ detail.owner_unionid)
					}		
				}}>
					<div className='left-box'>
						<img className='msg-img' src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20240221/d542a1fdb85c9cdbe73ec49383ae7924.png"></img>
						<span>{this.state.groupList && this.state.groupList.length > 0 ? this.state.groupList.length : 0}个指定群参加</span>
					</div>
					<span>设置 ></span>
					{
						WxApi.isMobile() && WxApi.isWeixn() ?
						<wx-open-launch-weapp
							id="launch-btn" style={miniBtnStyle}
							username="gh_ae6449501a82"
							path={detail.eid ? this.wxJumpPath : '/pages/default/default.html'}
							>
							<script type="text/wxtag-template">
								<div style={miniBtnStyle}>
									
								</div>
							</script>
						</wx-open-launch-weapp> : null
					}
				</div>
			</div>
		)
	}
	//底部提交通知展示权限：对齐小程序 groupfooter.wxml（info_id || is_admin || is_owner || sup_vip）
	//发起人/管理员自己未报名（无 info_id）时也要展示通知，H5 兼容 admins_node/admin1/admin3 标记位
	canShowSubmitNotice(detail){
		return !!(detail.info_id
			|| Number(detail.is_owner) === 1
			|| Number(detail.is_admin) === 1
			|| Number(detail.admin1) === 1
			|| Number(detail.admin3) === 1
			|| (detail.admins_node && detail.admins_node.length > 0)
			|| Number(detail.sup_vip) === 1);
	}
	//自定义提交通知
	renderNotice(detail){
		// Keep the activity context in the fallback URL while router navigation preserves MobX detail state.
		const noticeHref = withAppBasename('/notice?eid=' + encodeURIComponent(detail.eid || ''));
		const {wxNotice} = this.props.myEnrollStore;
		let noticeArr = wxNotice.msg_list;
		let sms_list = wxNotice.sms_list;
		if(noticeArr && noticeArr.length > 0){
			noticeArr = noticeArr.filter(item => !item.time_out || item.time_out == 0);
		}
		
		const miniBtnStyle = {
			width: '414px',
		    height:'40px',
		    background:'#f7f7f7',
		   }
		   
		if(noticeArr && noticeArr.length > 0 &&  noticeArr[0].content && this.canShowSubmitNotice(detail)){
			return(
				<div className="notice-body-panel">
					<a className="notice-box" href={noticeHref} onClick={(event) => {
							event.preventDefault();
							sessionStorage.setItem("noticeTab",0);
							this.props.history.push('/notice?eid=' + encodeURIComponent(detail.eid || ''));
						}}>
						<img className='notice-icon' src={ic_top_notice} />
						<p className='notice-content'>{noticeArr[0].content}</p>
						<img className='icon-row' src={ic_top_row} />
					</a>
					{this.state.isWeixin ? <div className="notice-box-opacity">
					<wx-open-launch-weapp
						  id="launch-btn"
						  username="gh_ae6449501a82"
						  path={detail.eid ? this.wxJumpPath +'&open_type=notice' : '/pages/default/default.html'}
						>
						<script type="text/wxtag-template">
							 <div style={miniBtnStyle}>
								
							 </div>
						</script>
					</wx-open-launch-weapp>
				</div> : null}
				</div>
			)
		}else if(sms_list && sms_list.length > 0){
			return (
				<div className="notice-body-panel">
						<a className="notice-box" href={noticeHref} onClick={(event) => {
								event.preventDefault();
								sessionStorage.setItem("noticeTab",0);
								this.props.history.push('/notice?eid=' + encodeURIComponent(detail.eid || ''));
							}}>
							<img className='notice-icon' src={ic_top_notice} />
							<p className='notice-content'>{sms_list[0].content}</p>
							<img className='icon-row' src={ic_top_row} />
						</a>
						{this.state.isWeixin ? <div className="notice-box-opacity">
						<wx-open-launch-weapp
							id="launch-btn"
							username="gh_ae6449501a82"
							path={detail.eid ? this.wxJumpPath + '&open_type=notice' : '/pages/default/default.html'}
							>
							<script type="text/wxtag-template">
								<div style={miniBtnStyle}>
									
								</div>
							</script>
						</wx-open-launch-weapp>
					</div> : null}
				</div>
			)
		}else if(detail && detail.follow && detail.follow.type > 0 && (detail.follow.desc||detail.follow.qrcode||detail.follow.link_url) && (this.canShowSubmitNotice(detail) || detail.on_behalf == 1)){
			return(
				<div className="notice-body-panel">
					<a className="notice-box" href={noticeHref} onClick={(event) => {
							event.preventDefault();
							sessionStorage.setItem("noticeTab",1);
							this.props.history.push('/notice?eid=' + encodeURIComponent(detail.eid || ''));
							
						}}>
						<img className='notice-icon' src={ic_top_notice} />
						<p className='notice-content'>{ detail.follow.desc || '已参加活动的小伙伴，请点击查看'}</p>
						<img className='icon-row' src={ic_top_row} />
					</a>
					{this.state.isWeixin ? <div className="notice-box-opacity">
						<wx-open-launch-weapp
							  id="launch-btn"
							  username="gh_ae6449501a82"
							  path={detail.eid ? this.wxJumpPath + '&open_type=notice&notice_type=1' : '/pages/default/default.html'}
							>
							<script type="text/wxtag-template">
								 <div style={miniBtnStyle}>
									
								 </div>
							</script>
						</wx-open-launch-weapp>
					</div> : null}
				</div>
			)
		}
	}
	
	
    //banner图片
    renderBanner(detail) {
    	let imgHeight = document.body.offsetWidth * 0.6;
		let endTime = EnrollServers.formatDate(detail.end_time * 1000, 'yyyy-MM-dd HH:mm');
    	if(detail.banner) {
    		return (<Fragment>
	            <div className="Detail-header-image">
	            <img className='enroll-detail-img' onClick={() => {
	                React.$wx.previewImage({
	                    current: detail.banner, // 当前显示图片的http链接
	                    urls: [detail.banner] // 需要预览的图片http链接列表
	                });
	            }} src={WxApi.getAutoImage(detail.banner, 750, 'single')}/>
	            </div>
	        </Fragment>);    		
    	}else if(detail.video && detail.video.url){
    		return(<div className="Detail-header-image" style={{height: imgHeight}}>
				<video className="video-banner" src={detail.video.url} controls="controls" poster={detail.video.pic_url}></video>
			</div>);
    	}else if(detail.banner === null){
			return (<div className="Detail-header-image"><div className='enroll-detail-img'></div></div>)
		}

    }

		// Display the existing fallback advert for non-VIP group details.
		renderAdvert(){
			return (
				<div className="lottery-box" onClick={()=>{
					window.open('https://xcx.qunsou.co/recommend.html?appId=wxfaa08012777a431e');
				}}>
					<img className="lottery-banner" src={this.state.lotteryBanner} />
				</div>
			)
		}

    //活动内容
    renderContent1(detail) {
        if(detail.temp !=6)return
		let listItem = [
			{
				img: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/354236005ef43fa149a8a80d09942f7b.png',
				isShow: !!detail.act_start,
				title: "活动：",
				content: detail.actStartTime + " - " + detail.actEndTime,
				isTime: true,
				dateTime: detail.act_end ? new Date(detail.act_end * 1000).toISOString() : ''
			},
			{
				img: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/5d5a06f07bf908516ba4af0f3c939764.png',
				isShow: !!detail.address,
				title: "地址：",
				content: detail.address, //TODO 这里需要添加定位,
				action: () => {
					if(!detail.address_type || detail.address_type ==0){
						if(WxApi.isMobile() && WxApi.isWeixn()){
							if(!Config.TOKEN){
								React.$wx.webLogin();
								return;
							}
							window.wx.openLocation({
								latitude: detail.latitude, // 纬度，浮点数，范围为90 ~ -90
								longitude: detail.longitude, // 经度，浮点数，范围为180 ~ -180。
								address: detail.address, // 地址详情说明
								scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
							});
						}else{
							const linkElement = document.createElement('a');
							linkElement.target="_blank";
							linkElement.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${detail.latitude},${detail.longitude};title:活动地址;addr:${detail.address}&referer=myapp`
							// linkElement.href = `https://api.map.baidu.com/marker?location=${detail.latitude},${detail.longitude}&title=活动地址&content=${detail.address}&output=html&src=地图&ak=G1RjyBHcccDk6pb865C4FrPXjcpB2eKM`						
							const clickEvent = new MouseEvent('click', {
								view: window,
								bubbles: true,
								cancelable: true
							});							
							linkElement.dispatchEvent(clickEvent);
						}						
					}else{
						this.setState({showLink:true});
					}
					
				}
			},
		]
        return (
            <section className="Detail-content1">
                <h1 className="Detail-title">
                    {detail.title}
                </h1>
                <Flex className="Detail-subtitle" align={"around"} style={{position: 'relative'}}>
				{
					detail.team_items ? <div>
						<span className='price-tuan'>￥{detail.team_items.team_fee/100}</span>
						<span className='price-single'>￥{detail.team_items.fee/100}</span>
						<span className='price-text'>{detail.team_items.team_num}人拼团</span>
					</div> : ''
				}               				
				{
					!detail.team_items && detail.items && detail.items.length ? <div>
						<span className='price-tuan'>￥{detail.items[0].team_fee/100}</span>
						<span className='price-single'>￥{detail.items[0].fee/100}</span>
						<span className='price-text'>{detail.items[0].team_num}人拼团</span>
					</div> : ''
				}              				
				<button className="detail-notice-btn" style={{color: this.state.themColor}} onClick={() => {
						if(detail.is_fans){					
							this.child.setDialog('open')
						}else{
							window.location.href = 'https://mp.weixin.qq.com/s/7xoT8N4jJuR36X3UoZEQVg'
						}
					}}>					
					<span>订阅&nbsp;</span>
					<i className="notice-icon iconfont icon-svg45-copy" style={{color: this.state.themColor}}></i>
				</button>
                </Flex>
 				<Flex className="Detail-content" direction={"column"} align={"start"} justify={"center"}>
					{
						listItem.map((item, index) => {
							if (item.isShow) {
								return (
									<Flex.Item key={index} className="Detail-content-text">
										<img src={item.img}/>
										<div className="Detail-content-right">
											{ !this.state.isVertical ? <span>{item.title}</span> : null }	                              
											{
												item.isTime ?
												<time className={item.action ? "action" : ""} dateTime={item.dateTime}>{item.content}</time>
												:
												<span className={item.action ? "action" : ""} onClick={() => {
													if (item.action) {
														item.action();
													}
												}}>{item.content}</span>
											}
										</div>
									</Flex.Item>
								)
							}
						})
					}
				</Flex>
            </section>
        )
    }
	
 	getHeader(detail){
    	if(detail.auth == 1){
    		return(<img className='min-img-header' src={detail.owner_pic||Config.defaultAvatar}/>)
    	}else{
    		return(<img src={detail.owner_pic||Config.defaultAvatar} />)
    	}
    	
    }

    //输出发起人相关信息
    renderOwner(detail) {
        let icon = null;
//      let text = detail.is_owner ? "非VIP" : "";
		let text = "";
        let signName = detail.sign_name;   
		switch (detail.auth) {
			case 1:
				icon = img_identification_p;
				text = "个人";
				if(!detail.cert_show){
					signName = detail.sign_name.substr(0,1) + "**";
				}
				break;
			case 2:
				icon = img_identification_c;
				text = "机构";
				break;
			case 3:
				icon = img_identification_c;
				text = "机构";
				break;
			case 4:
				icon = img_identification_g;
				text = "公众号";
				break;
			default:
				icon = null;
				break
		}
        
        let summary = detail.summary;
        if(detail.auth >1){
	        if(!summary || summary.length<=0){
	        	summary = "Ta组织活动太忙，还没有腾空写简介"
	        }
        }
        
		let btnColor = {backgroundColor: '#00a8f3'};
		if(detail && detail.btn_config && detail.btn_config.color){
			btnColor.backgroundColor = detail.btn_config.color;
		}

        return (
        	<section className="Detail-role-panle">
            <div className="Detail-originator">
				<div className="originator-info-panel">
                <div className="originator-info" onClick={()=>{
						window._hmt.push(['_trackEvent', 'button_to_homepage','', '活动详情点击主页', '']); //百度统计
						React.$wx.jumpNewPath.call(this,'/h/'+detail.owner_unionid)
					}}>
	            	 <div className='detail-originator-left'>
					 {
	            	 	this.getHeader(detail)
	            	 }
	            	 <div className="originator-type">
	            	 	<h3 className="originator-top">				          
		            	 	 <span>{signName}</span>
	            	 	</h3>
						<div>
							{
								detail.auth > 0 && detail.role ? <div style={btnColor} className="auth-type-parent">
									<img className="auth-icon" src={ic_person_identity} />
									<label>{text}</label>
								</div> : null
							}
							<div className='send-message' onClick={(e)=>{
								e.stopPropagation()
								if(!Config.TOKEN){
									React.$wx.webLogin()
								}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){
									this.getTicket(detail)
								}else{							
									WxApi.setMessageUserStyle(detail.user_style);
									this.props.history.push('/message')							
								}
							}}><i className="iconfont icon-xinxi"></i>&nbsp;留言</div>
						</div>
	            	 </div>
					 </div>
	                <a className="detail-originator-right" href={withAppBasename('/h/' + detail.owner_unionid)} onClick={()=>{
						window._hmt.push(['_trackEvent', 'button_to_homepage','', 'activity_detail_open_homepage', '']);
					}}>
						主页
						<img className="arrow-share" src={right_arrow} />
					</a>
            	</div>
				</div>
				  { detail.summary ? <div className='owner-desc'>{detail.summary}</div>  : '' }				 				   
            </div>
            </section>
        )
    }

	// 消息订阅弹窗
	renderMsgDialog(detail){
		let signName = detail.sign_name;
		if(detail.auth == 1 && !detail.cert_show){
			let nameArr = detail.sign_name.toString();
			signName = nameArr[0] + '**';
		}
		return <NewMsgDialog ref="messageDom" signName={signName} owner_pic={detail.owner_pic || Config.defaultAvatar} sub_user={this.state.sub_user} 
		owner_unionid={detail.owner_unionid} onRef={(ref)=>{ this.child = ref}}/>
	}
	// 联合创作
	renderEnrollGroup(detail){
		let list = {					
			1:'共创',
			2:'嘉宾',
			3:'联名',
			4:'赞助',
			5:'联名'
		}
		return (
			<ul class="team-user-panel">
				<li className='team-list'>
					<div class="team-avatar">
						<img class="team-img" src={detail.owner_pic || Config.defaultAvatar} />
						<span class="team-tag">发起</span>	
						<img class="auth-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230705/872afef5e0be594e97fd9eaaf60f5fd1.png"></img> 
					</div>
					<span class="team-uname">{WxApi.getDefaultName(detail.sign_name)}</span>	
				</li>
				{
					detail.team_user.map((item,index)=>{
						return (
							<li class="team-list" key={index} onClick={()=>{
								React.$wx.jumpNewPath.call(this,'/h/'+item.unionid);
							}}>				
								<div class="team-avatar">
										<img class="team-img" src={item.upic || Config.defaultAvatar} />
										<span class="team-tag">{list[item.type]}</span>	
										{
											item.is_auth ? 
											<img class="auth-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230705/872afef5e0be594e97fd9eaaf60f5fd1.png"></img> : ''
										}										
								</div>				
								<span class="team-uname">{item.uname}</span>											 			 
							</li>		
						)
					})
				}
			</ul>
		)
	}

    renderFastJoin(detail){
    	let _this = this;
		let _fast = JSON.parse(sessionStorage.getItem("fastArr"));
		if(detail.status == 1 && detail.fast_team == 1 && _fast && _fast.length > 0 && _fast[0].team_num > 1 && _fast[0].team_num > _fast[0].joins){
			
				return(<div className="fast-join-panel">
					<div className="fast-panel-title">快速成团</div>
				{
					
					_fast.map(function(item,index){
						if(item.team_num > item.joins && item.fail == 0){
							return (
				                <Flex key={index} className="Detail-list-item">
				                
				                    {
				                    	item.heads && item.heads.length ? item.heads.map(function(header,index){
				                    		if(index <5){
				                    			return (<img className="header-img" src={header||Config.defaultAvatar}/>)
				                    		}
				                    		
				                    	}) : <img className="header-img" src={Config.defaultAvatar}/>
				                    }
				                    <div className="Detail-list-flexpanel">
				                    	
				                    </div>
			                       <Flex.Item className="Detail-item-des mr0"  >
			                          {
			                          	item.has_join ? <div className={"group-info"} >
	                            <span>还差  <span className={"people-num"}>{item.team_num - item.joins}</span> 人成团</span>
	                            <Button inline  className={"team-btn"} onClick={()=>{ 
	                            	_this.props.enrollStore.setTeamId(item.tid)
									_this.props.myEnrollStore.setCurrentEnroll({info_id: item.info_id})  
	                            	_this.props.history.push('/groupCert')
	                            }}>查看团</Button>
	                        </div> :<div className={"group-info"}>
			                            <span>还差 <span className={"people-num"}>{item.team_num - item.joins}</span> 人成团</span>
			                            <Button inline  className={"team-btn join-btn"} onClick={()=>{ 
											if(Config.TOKEN){
												_this.props.enrollStore.getItemData().then(()=>{
													var enrollStore = _this.props.enrollStore;
													enrollStore.setTeamId(item.tid);
													_this.props.history.push('/enrollGroupForm')
												})												
											}else{
												React.$wx.webLogin();
											}			                            	
			                            }}>去参团</Button>
			                        </div>
			                          }
			                          
			                        </Flex.Item>
				                </Flex>
				            );
						}
						
						
					})
				}
				</div>)
			
			
			
		}
    	
    }
    
    renderPlay(){
    	return(
    		<div className="play-group-tips">
    			<h3 className="play-title">拼团玩法</h3>
    			<img src={img_pintuan_tips} />
    			<div className="play-step">
    				<div className="step-item">
    					<div>选择商品</div>
    					<div>开团拼团</div>
    				</div>
    				<div className="step-item">
    					<div>付款邀请</div>
    					<div>好友参团</div>
    				</div>
    				<div className="step-item">
    					<div>达到人数</div>
    					<div>拼团成功</div>
    				</div>
    				<div className="step-item">
    					<div>拼团失败</div>
    					<div>自动退款</div>
    				</div>
    			</div>
    		</div>
    	)
    	
    }

	//获取描述内容
	getContent(detail){
		if(detail.content && detail.content !="无"){
       		return(<pre className="Detail-describe-img">{detail.content}</pre>)
       	}else{
       		return(<div className="nullData"></div>)
       	}
	}


    //输出描述
    renderDescribe(detail) {
        let enrollStore = this.props.enrollStore;
        return (
            <section className="Detail-describe-section">
            <Flex className="Detail-describe group-detail-describe" direction={"column"}>
                <Flex.Item
                    className={"Detail-describe-content" + ((detail.content == "无" || enrollStore.describeShow) ? "" : " hide")}>
                    {
                   		Array.isArray(detail.content)?detail.content.map((item,index)=>{
							const style = {
								color: item.color || '#333',
								fontSize: item.font_size / 2 || 16 + 'px',
								textAlign: item.text_align || 'left',
								fontWeight: item.font_weight || 'normal'
							}
	                   			if(item.type == "text" && item.value){
									if(index == 0){
										let description = item.value.substring(0,100)
										document.getElementsByTagName('meta')[4].setAttribute("content",description)
									}
									return(<pre className="Detail-describe-img" key={index} style={style}>{item.value}</pre>)
								}else if(item.type == "img" || item.type == 'img_hd'){
									return(<div key={index} className="Detail-describe-img detail-img"><img src={item.value} /></div>)
								}
								else if (item.type == "file"){
									let colorType = 'bg-default';
									let fileList = {
										'W':'bg-blue',
										'doc':'bg-blue',
										'X':'bg-green',
										'pdf':'bg-red',
										'P':'bg-orange'
									}
									if(fileList[item.file_type]){
										colorType = fileList[item.file_type];
									}		
									let file_index = item.name.lastIndexOf('.');
                   					return(<div key={index} onClick={() => {
											if(item.download == 1){ //只可查看不可下载
												if((!WxApi.isMobile() || WxApi.isOtherEnvironments()) && !WxApi.isWeixn()){ //pc浏览器					
													this.showDetailQrCode('block');
												}else if(WxApi.isWeixn() && !Config.token){
													React.$wx.webLogin();
												}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){//手机浏览器				
													this.getTicket(detail);
												}										
											}else{
												window.location.href = item.url;
											}			
                                         }} className="rule-file-item">
											<div className={["rule-file-type "+ colorType].join('')}>{item.file_type}</div>
											<div className="rule-file-name">{file_index > -1 ? item.name.substring(0,file_index) : item.name}</div>
											{
												item.download != 1 ? <img className='down-btn' src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230426/0632028fda6d1c479fab874370e9fa80.png"></img> : ''
											}
											{
												WxApi.isWeixn() && WxApi.isMobile() && item.download == 1 ?
												<wx-open-launch-weapp												
													id="jump-wx-btn"
													username="gh_ae6449501a82"
													path={detail.eid ? this.wxJumpPath : '/pages/default/default.html'}
													>																						
													<script type="text/wxtag-template">
														<div style={{width:'100%',height:'60px'}}></div>
													</script>																						
												</wx-open-launch-weapp> : ''
											}		
										  </div>)
								}else if(item.type == 'adress'){
									return (
										<div className='adress-box' onClick={()=>{
											if(WxApi.isMobile() && WxApi.isWeixn()){
												if(!Config.TOKEN){
													React.$wx.webLogin();
													return;
												}
												window.wx.openLocation({
													latitude: item.latitude, // 纬度，浮点数，范围为90 ~ -90
													longitude: item.longitude, // 经度，浮点数，范围为180 ~ -180。
													address: item.value, // 地址详情说明
													scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
												});
											}else{
												const linkElement = document.createElement('a');
												linkElement.target="_blank";
												linkElement.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${item.latitude},${item.longitude};title:地址;addr:${item.value}&referer=myapp`
												// linkElement.href = `https://api.map.baidu.com/marker?location=${detail.latitude},${detail.longitude}&title=活动地址&content=${detail.address}&output=html&src=地图&ak=G1RjyBHcccDk6pb865C4FrPXjcpB2eKM`						
												const clickEvent = new MouseEvent('click', {
													view: window,
													bubbles: true,
													cancelable: true
												});							
												linkElement.dispatchEvent(clickEvent);
											}
										}}>
										   <img src={icon_adress} className="adress-img" />
										   <span> {item.value}</span>
										</div>
									)
								}else if(item.type == 'url'){
									return (
										<div key={index} className="article-box" onClick={()=>{
											window.location.href = item.link;
										}}>
											<img src={item.icon} className="article-img"></img>
											<p className="article-title">{item.value}</p>
										</div>
									)
								}else if(item.type == 'video'){
									return (
									   <video width="320" height="240" controls="controls" style={{display:'block',margin:'10px auto'}}>
										   <source src={item.value} type="video/mp4" />
									   </video>
									)
								}else if(item.type == 'copy'){
									return (
										<div className="applet-box flex-between-box" onClick={()=>{
											WxApi.copeText(item.value)
											Toast.success('复制成功')							
										}}>											 
											<img className="applet-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230220/bbc74473a300035bee8247e1037e4adb.png" />
											<div className="applet-content">												
												<p className="copy-desc">{item.desc}</p>															
												<span>{item.value}</span>																					
											</div>
											<Button type="primary" className="open-btn">复制</Button>
										</div>
									 )
								}else if(item.type == 'program'){
									const miniBtnStyle = {
										display:'inline-block',
										width:'70px',
										height:'28px',
										padding:'10px 0',																	
										position:'absolute',
										right: '10px',
										top:'7px',
										zIndex:"10"					
									}
									let defaultAppLog = "https://cdn-xcx-qunsou.weiyoubot.cn/material/20230220/4bb82882884598314f9ab20e78f55328.png";
								   	return (
										<div className="applet-box flex-between-box">  
											<img className="applet-img" src={item.logo||defaultAppLog} />                     											
											<div className="applet-content">
												<span>{item.value}</span>
												<p className="applet-desc">{item.desc}</p>
											</div>
											<Button type="primary" className="open-btn" onClick={()=>{
												if(item.mini_type > 0){
													window.open(item.path);
												}												
											}}>打开</Button>
											{
												item.mini_type == 0 ? 
												<wx-open-launch-weapp id="launch-btn" style={miniBtnStyle} username={item.originalId} path={item.path}>
													<script type="text/wxtag-template">														
														<span style={miniBtnStyle}></span>												
													</script>
												</wx-open-launch-weapp> : ''
											}																				
										</div>
									)
								}else if(item.type == 'channel'){
									return (
										<div className="channel-box">
											<img className="channel-img" src={icon_video_img}/>                      
											<span>{item.value}</span>
										</div>
									)
								}else if(item.type == 'audio'){
									return (
										<div className="audio-box">
											<div className="audio-main" onClick={()=>{
												 if(this.state.currAudioIndex == index){
													this.audioBox.pause();
													this.state.currAudioIndex = -1;
												}else{
													if(!this.audioBox){
														this.audioBox = new Audio();
													}
													this.audioBox.src = item.path;
													this.audioBox.addEventListener('ended',()=>{ //语音播放完毕
														this.setState({ currAudioIndex: -1 });                
													});
													this.audioBox.play();													 
													this.setState({ currAudioIndex: index });
												} 
											}}>     
												{
													index == this.state.currAudioIndex ?
													<img className="audio-play-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230706/46e95d5bad6311ee3baa23f62f144377.gif"></img>
													:
													<img className="audio-play-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230706/2f2983dd7572c12401096261d73bea12.png"></img>
												}
												<span>{item.duration}″</span>
											</div>                        
										</div>  
									)
								}		 	                   			
	                   		}):this.getContent(detail)
                   }
                    
                </Flex.Item>
            </Flex>
            </section>
        )
    }

	renderGroupButton(detail){
		if(detail.temp != 6)return
		let btnColor = {
			backgroundColor:"#00a8f3"
		}
		if(detail && detail.btn_config && detail.btn_config.color){
			btnColor.backgroundColor = detail.btn_config.color;
		}
		let { timeInfo } = this.state;
		if(Config.TOKEN){
			if(detail.status == 2 && !detail.info_id){
				return (
					<Button type="primary" style={btnColor} onClick={()=>{
						this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
						this.props.history.push('/cert');
					}}>已截止</Button>
				)
			}else if(detail.status == 2 && detail.info_id) {
				return(
					<Button type="primary" style={btnColor} onClick={() => {
						this.props.myEnrollStore.setCurrentEnroll(0);
						if(detail.info_id){
							let params = {
								team_fee:detail.team_items.team_fee/100,
								fee:detail.team_items.fee/100,							
								sub_user_type:detail.sub_user_type,
								btn_config:detail.btn_config,
								btn_type: detail.btn_type,
							}
							sessionStorage.setItem('groupInfo',JSON.stringify(params))
							this.props.history.push('/group-orders')
						}
	                }}>查看/取消</Button>)
			}else if(detail.status == 0){
				return (
					<Button type="primary" className='detail-submit-btn' style={btnColor} onClick={()=>{
						this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
						this.props.history.push('/cert');
					}}>
						<span>未开始</span>
						{
							!this.state.isHideBtn && detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2) ? 
							<span className="cen-countdown">剩余{timeInfo.hour}小时{timeInfo.minute}分钟{timeInfo.second >= 10 ? timeInfo.second : '0' + timeInfo.second}秒</span> : ''
						} 
					</Button>
				)
			}else if(detail.status == 1 && detail.info_id && detail.on_behalf_limit != 0) {
				return(
					<Button type="primary" className='detail-submit-btn' style={btnColor} onClick={async () =>{
						let params = {
							team_fee:detail.team_items.team_fee/100,
							fee:detail.team_items.fee/100,					
							sub_user_type:detail.sub_user_type,
							btn_config:detail.btn_config,
							btn_type:detail.btn_type,
						}
						sessionStorage.setItem('groupInfo',JSON.stringify(params));
						this.props.history.push('/group-orders');			
					} }>
						<span>新增/取消</span>
						{
							!this.state.isHideBtn && detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2) ? 
							<span className="cen-countdown">剩余{timeInfo.hour}小时{timeInfo.minute}分钟{timeInfo.second >= 10 ? timeInfo.second : '0' + timeInfo.second}秒</span> : ''
						} 
					</Button>)	 
			}else {
				return (
					<div className="group-buy-btn">
						<Button type="primary" className="single-buy detail-submit-btn" style={btnColor} inline onClick={async ()=>{						
							this.props.myEnrollStore.setCurrentEnroll(0);
							await this.userNickname.checkUserName(); //判断是否有昵称
							if(detail.info_id){
								let params = {
									team_fee:detail.team_items.team_fee/100,
									fee:detail.team_items.fee/100,									
									sub_user_type:detail.sub_user_type,
									btn_config:detail.btn_config,
									btn_type:detail.btn_type,
								}
								sessionStorage.setItem('groupInfo',JSON.stringify(params))
								this.props.history.push('/group-orders')
							}else if(detail.sub_user_setting && detail.sub_user_setting.length && detail.sub_user_setting.indexOf('all') == -1 && detail.sub_user_setting.indexOf('white') == -1){						 
								if((detail.sub_user_setting.indexOf('vip') != -1 && this.state.vipList.length > 0) || (detail.sub_user_setting.indexOf('fans') != -1 && detail.sub_user)){
									if(detail.team_items.fee == 0){ //只要单购价格为0，那就只能团购
										this.props.enrollStore.getItemData().then(()=>{
											this.props.enrollStore.setTeamId(null)
											var enrollStore = this.props.enrollStore;
											enrollStore.setIsteamBuy(1);								 
											this.props.history.push('/enrollGroupForm');
										})		
									}else{
										await this.getEnrollStatus(detail);
										await this.childNotice.checkHasToken(); //检测是否有提交前设置
										this.setState({groupDialog:true})
									}	
								}else if(detail.sub_user_setting.indexOf('fans') != -1 && !detail.sub_user){
									Modal.alert('温馨提示','你还不是当前组织的粉丝，不能参加此活动，请先去关注活动组织者', [
										{ text: '取消', style: 'default'},
										{ text: '去关注', onPress: () => {	
											React.$wx.jumpNewPath.call(this,'/h/'+sessionStorage.getItem('owner_unionid'))
										} },
									])
								}else if(detail.sub_user_setting.indexOf('vip') != -1 && !this.state.vipList.length){
									Modal.alert('需先获取会员卡','本活动仅限持有会员卡的用户提交，请点击获取会员卡了解详细内容', [
										{ text: '取消', style: 'default'},
										{ text: '获取会员卡', onPress: () => {	
											React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+detail.items_fee.vip_card_id)
										} },
									])
								}else if(detail.sub_user_setting.indexOf('end_all') != -1){
									Modal.alert('温馨提示','发起人设置了所有人不可提交，暂时无法提交', [
										{ text: '取消', style: 'default'},
										{ text: '去留言', onPress: () => {	
											React.$wx.jumpNewPath.call(this,'/message')
										} },
									])								 
								}else{
									if(detail.team_items.fee == 0){ //只要单购价格为0，那就只能团购
										this.props.enrollStore.getItemData().then(()=>{
											this.props.enrollStore.setTeamId(null)
											var enrollStore = this.props.enrollStore;
											enrollStore.setIsteamBuy(1);								 
											this.props.history.push('/enrollGroupForm');
										})		
									}else{
										await this.getEnrollStatus(detail);
										await this.childNotice.checkHasToken(); //检测是否有提交前设置
										this.setState({groupDialog:true})
									}	
								}						 
							}else if(detail.team_items.fee == 0){ //只要单购价格为0，那就只能团购
								this.props.enrollStore.getItemData().then(()=>{
									this.props.enrollStore.setTeamId(null)
									var enrollStore = this.props.enrollStore;
									enrollStore.setIsteamBuy(1);								 
									this.props.history.push('/enrollGroupForm');
								})		
							}else{
								await this.getEnrollStatus(detail);
								await this.childNotice.checkHasToken(); //检测是否有提交前设置
								this.setState({groupDialog:true})
							}							
						}}>
							<span>{detail.btn_config && detail.btn_config.text ? detail.btn_config.text : this.state.btnTypeText[detail.btn_type]}</span>
							{
								!this.state.isHideBtn && detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2) ? 
								<span className="cen-countdown">剩余{timeInfo.hour}小时{timeInfo.minute}分钟{timeInfo.second}秒</span> : ''
							} 
						</Button>											
					</div>
				)				
			}
			
		}else {
			return (
				<Button type="primary" style={btnColor} onClick={()=>{
					this.showMinProgram()
				}}>{detail.btn_config && detail.btn_config.text ? detail.btn_config.text : this.state.btnTypeText[detail.btn_type]}</Button>	
			)	
		}
	}
	// 倒计时
	getTimeDown(detail){
		if(this.timeDown)clearInterval(this.timeDown);
		let endTime = detail.end_time * 1000;
		if(detail.btn_config.btn_cd == 2){
			endTime = detail.start_time * 1000;
		}
		let nowTime = new Date().getTime();
		let time = endTime - nowTime;		
		if(time > 0){
			let hour = Math.floor(time / 1000 / 60 / 60);
			let minute = Math.floor(time / 1000 / 60 % 60);
			let second = Math.floor(time / 1000 % 60);
			this.setState({
				timeInfo: {
					hour,
					minute,
					second
				}
			})
			this.timeDown = setInterval(() => {				
				if(second > 0){
					second--;
				}else{
					second = 59;
					if(minute > 0){
						minute--;
					}else{
						minute = 59;
						if(hour > 0){
							hour--;
						}else{
							clearInterval(this.timeDown);
							detail.status = detail.btn_config.btn_cd == 2 ? 1 : 2;	
							if(detail.status == 2)this.props.enrollStore.isEnd = true;							
							this.setState({hour: 0, minute: 0, second: 0, detail, isHideBtn: true});		
							return;					 
						}
					}
				}
				this.setState({
					timeInfo: {
						hour,
						minute,
						second
					}
				})
			}, 1000)
		}else{
			this.setState({isHideBtn: true});
		}
	}
	// 判断发起人是否设置了所有人不可提交
	getEnrollStatus(detail){
		return new Promise((resolve,reject)=>{
			if(detail.sub_user_type == 'end_all'){
				Modal.alert('温馨提示','发起人设置了所有人不可提交，暂时不可提交', [
					{ text: '取消', style: 'default'},
					{ text: '去留言', onPress: () => {	
						WxApi.setMessageUserStyle(detail.user_style);
						this.props.history.push('/message') 
					} },
				])
				reject()
			}
			resolve()
		})		
	}

	renderGroupModal(detail){
		if(!detail||!detail.team_items)return
		return (
			<Modal visible={this.state.groupDialog} maskClosable={false} animationType="slide-up" popup  className='m-group-modal'>					
				<div className='flex-between-box'>
					<h4 className='m-group-title'>请选择购买方式</h4>
					<img className='m-close-img' src={icon_close_img} onClick={()=>{
						this.setState({groupDialog:false})
					}}/>
				</div>
				<ul className='m-group-list'>
					<li className='m-group-items' onClick={()=>{
						this.props.enrollStore.getItemData().then(()=>{
							this.props.enrollStore.setTeamId(null)
							var enrollStore = this.props.enrollStore;
							enrollStore.setIsteamBuy(1);
							this.setState({groupDialog:false});
							this.props.history.push('/enrollGroupForm');
						})						
					}}>
						<span className='m-buy-collage'>￥{detail.team_items.team_fee/100}拼团购买</span>
						<Button className='m-buy-btn' type='warning'>我要开团</Button>
					</li>				 
					<li className='m-group-items' onClick={()=>{
						this.props.enrollStore.getItemData().then(()=>{
							var enrollStore = this.props.enrollStore;
							enrollStore.setIsteamBuy(2);
							this.setState({groupDialog:false});
							this.props.history.push('/enrollGroupForm');
						})						
					}}>
						<span className='m-buy-alone'>￥{detail.team_items.fee/100}单独购买</span>
						<Button className='m-buy-btn' type='primary'>单独购买</Button>
					</li>						
				</ul>
			</Modal>
		)
	}


    shareImg(type) {
        this.props.enrollStore.getShare(type).then((d) => {
            if (d && d.url) {
                React.$wx.previewImage({
                    current: d.url, // 当前显示图片的http链接
                    urls: [d.url] // 需要预览的图片http链接列表
                });
            }
        });
    }
    
	handleTransfor(detail){
		if(detail.is_owner){
			Modal.alert('温馨提示','不能转载自己的活动',[{ text: '我知道了' }]);
			return;
		}
		const params = {
			eid: detail.eid,
			type: 'sub'
		}
		this.props.myEnrollStore.reshippedEnroll(params).then(res=>{
			if(res.sta == 0){
				this.showSharePanel('none');
				Modal.alert('温馨提示', '转载成功，请到你的个人主页查看', [					
					{ text: '取消', onPress: () => console.log('ok')},
					{ text: '前往主页查看', onPress: () => {
						React.$wx.jumpNewPath.call(this,'/h/'+detail.unionid);
					}},
				]);			
			}else{
				Toast.fail(res.msg);
			}
		})
	}
	
    showSharePanel(type){
		this.setState({
	        sharePanel: type,
	    })
	}

	goGroupSharePage(tab, detail) {
		// 传递入口权限上下文，避免分享页详情接口未返回权限字段时误展示内容。
		let sharePath = `/group-share?eid=${detail.eid}&tab=${tab}&share=${detail.share || 0}&info_id=${detail.info_id || 0}&is_owner=${detail.is_owner || 0}&is_admin=${detail.is_admin || 0}&admin1=${detail.admin1 || 0}&admin3=${detail.admin3 || 0}&canOpt=${detail.canOpt || detail.can_opt || 0}`;
		if(detail.unionid){
			sharePath += `&referer=${detail.unionid}`;
		}else if(Config.referer){
			sharePath += `&referer=${Config.referer}`;
		}
		this.setState({
			sharePanel: 'none',
		}, () => {
			this.props.history.push(sharePath);
		});
	}

    //分享选择面板
	renderSharePanel(is_show,detail) {
			// 团购线路与普通详情保持一致：share=1 时仅参与者可直接分享。
			const hasJoinedActivity = detail.info_id !== undefined && detail.info_id !== null && detail.info_id !== '' && detail.info_id !== 0 && detail.info_id !== '0';
			const canShareToFriend = Number(detail.share) !== 1 || hasJoinedActivity;
			return(
				<Flex className="Detail-share-choice-panel" style={{display:this.state.sharePanel}}>
	    			<div className="share-choice-mask" onClick={() => { this.showSharePanel('none')}}></div>
	    			<div className="share-choice-panel">
	    				<div className="share-btn-panel">
					{canShareToFriend ? <div className="share-icon" onClick={() => {
								let _url = `https://p.baominggongju.com/group?eid=${detail.eid}`;
								if(detail.unionid){
									_url += `&referer=${detail.unionid}`;		
								}else if(Config.referer){
									_url += `&referer=${Config.referer}`;							
								}
								WxApi.copeText(_url);														
								Toast.success('链接已复制');
								this.showFriend('block')
							}}>
	    						<i></i>
	    						<div>分享给好友</div>
					</div> : null}
	    					<div className="share-icon poster-img" onClick={() => { this.goGroupSharePage('poster', detail) }}>
	    						<i></i>
	    						<div>海报分享图</div>
	    					</div>
							<div className="share-icon wx-img" onClick={() => { this.goGroupSharePage('mini', detail) }}>
	    						<i></i>
	    						<div>小程序码</div>
	    					</div>
	    					<div className="share-icon qrcode-img" onClick={() => { this.goGroupSharePage('qrcode', detail) }}>
	    						<i></i>
	    						<div>二维码</div>
	    					</div>
							<div className="share-icon mobile-img" onClick={() => { this.goGroupSharePage('link', detail) }}>
	    						<i></i>
	    						<div>网页链接</div>
	    					</div>
							{/*
							<div className='share-icon command-img' onClick={()=>{								 
								this.props.history.push('/command');						
							}}>
								<i></i>
								<div>活动口令</div>
							</div>
							*/}
							{/* {
								detail.is_owner != 1 ? 
								<div className="share-icon transfor-img" onClick={() => {this.handleTransfor(detail)}}>
									<i></i>
									<div>转载到主页</div>
								</div> : ''
							} */}
	    				</div>
	    				<div className="cancel-btn" onClick={() => { this.showSharePanel('none')}}>取消</div>
	    			</div>
	    		
	    		</Flex>
			)
	}
	
	
	showMinProgram(){
		React.$wx.webLogin()
	}

	showDetailQrCode(type){
		if(type == 'block'){
			React.$wx.openWeChat(this.wxJumpPath).then(()=>{
				let self = this;
				this.props.enrollStore.getShare(1).then((d) => {
					if(d && d.url) {
						self.setState({
							showDetailQrCode: type,
							detailQrCode: d.url,
						})
						this.props.myEnrollStore.setShareImg(d.url);
					}
				});
			})	
		}else{
			this.setState({
				showDetailQrCode: 'none'
			})
		}				
	}
	//查看小程序二维码
	renderDetailQrCode(){
		return(
			<Flex className="Detail-minProgram-panel" style={{display:this.state.showDetailQrCode}}>
				<div className="share-choice-mask" onClick={() => { this.showDetailQrCode('none')}}></div>
				<div className="minProgram-panel">
					<div className="new-share-minImg">
						<i className="close-btn" onClick={() => { this.showDetailQrCode('none')}}></i>
						<div className="panel-title">请去「报名工具」小程序查看</div>
						<div className="QRCode-img">
							<img src={this.state.detailQrCode} />
						</div>
						<div className="min-tips">长按识别二维码，立即体验</div>
					</div>					
				</div>
			</Flex>
		)
	}

	showHomePageQrCode(type, detail){
		let self = this;
		this.props.enrollStore.getHomePageShare(detail.owner_unionid).then((d) => {
			if(d && d.url) {
				self.setState({
					showHomePageQrCode: type,
					detailQrCode: d.url,
				})
			}
		});

	}
	//查看小程序二维码
	renderHomePageQrCode(detail){
		return(
			<Flex className="Detail-minProgram-panel" style={{display:this.state.showHomePageQrCode}}>
				<div className="share-choice-mask" onClick={() => { this.showHomePageQrCode('none', detail)}}></div>
				<div className="minProgram-panel">
					<i className="close-btn" onClick={() => { this.showHomePageQrCode('none', detail)}}></i>
					<div className="panel-title">长按识别二维码，查看Ta的主页</div>
					<div className="QRCode-img">
						<img src={this.state.detailQrCode} />
					</div>
				</div>
			</Flex>
		)
	}
	// 查看活动口令
	renderEnrollToken(){
		return(
			<Modal
			visible={this.state.showEnrollToken}
			closable={true}
			transparent			
			onClose={()=>{this.setState({showEnrollToken:false})}}
			title="分享当前活动"				
		 	>
			<div className='modal-address-panel'>
				<p className='token-title'>参与人打开小程序可以直接进入活动页面</p>
				<p className='token-content'>{this.state.enroll_token} 打开报名工具小程序首页搜索</p>
				<Button type="primary" className='copy-btn' onClick={()=>{
					WxApi.copeText(this.state.enroll_token + ' 打开报名工具小程序首页搜索');
					Toast.success('复制成功');
					this.setState({showEnrollToken:false});
				}}>复制口令</Button>
			</div>
		  </Modal>			 
		)
	}
	// 复制微信
	renderWxLink(detail){		 
		return (
			<Modal
			visible={this.state.showWxlink}
			closable={true}
			transparent			
			onClose={()=>{this.setState({showWxlink:false})}}
			title="微信号"				
		 	>
			<div className='modal-address-panel'>
				<p className='address-content'>{detail.wx_no}</p>
				<Button type="primary" className='copy-btn' onClick={()=>{
					WxApi.copeText(detail.wx_no);
					Toast.success('复制成功');
					this.setState({showWxlink:false});
				}}>一键复制</Button>
			</div>
		  </Modal>
		)
	}

	// 有争议的活动
	renderCensorModal(){
		return (			 
			<Modal
			popup
			visible={this.state.censorModal}
			onClose={()=>{this.setState({censorModal: false })}}
			animationType="slide-up"	
			className='modal-censor-panel'						
			>
				<div className='main-container'>
					<div>
						<img className="warn-img" src="https://gw.alipayobjects.com/zos/rmsportal/GIyMDJnuqmcqPLpHCSkj.svg" />
						<h4 className='warn-title'>活动存在有争议的内容</h4>
						<span>请耐心等待协商解决</span>
					</div>
					<div className="footer-panel">
						<Button className='cen-button continue-btn' onClick={()=>{
							this.setState({ censorModal: false });
						}}>继续访问</Button>
						<Button className='cen-button cancel-btn' type="primary" onClick={()=>{
							this.setState({ censorModal: false });
							this.props.history.push('/manage/myEnroll');
						}}>取消</Button>
					</div>
				</div>					
			</Modal>			 
		)
	}

	showFriend(type){
		this.setState({
	        shareFriend: type,
	        shareMinProgram: 'none',
	        sharePanel: 'none',
	    })
	}
	renderShareTips(){
		return(
			<Flex className="Detail-share-tips-panel" style={{display:this.state.shareFriend}}>
				<div className="share-choice-mask" onClick={() => { this.showFriend('none')}}></div>
				<div className="tips-content" onClick={() => { this.showFriend('none')}}>
					<img className="arrow-share" src={img_mask_arrow} />
					<div className="share-text">
						<span>邀请链接已复制到剪切板</span><br/>
						<span>也可以点击右上角“...”完成分享</span><br/>	
					</div>
				</div>
			</Flex>
		)
	}
	
    
    
	showFriend(type){
		this.setState({
	        shareFriend: type,
	         sharePanel: 'none',
	    })
	}

    render() {
        let {detail, isEnd,isStart} = this.props.enrollStore;	 
		let _fast = JSON.parse(sessionStorage.getItem("fastArr"));
		let miniBtn = {
			flex:'1',
			height:'40px',
			backgroundColor:"#fff",
			border:'1px solid #ccc',
			cursor:'point',
			borderRadius:'5px',
		}
		const connection = navigator.connection || navigator.networkInformation;
		const networkType = connection && connection.effectiveType ? connection.effectiveType : '未知';
		const browserName = WxApi.getBrowserName();
		const userName = this.props.enrollStore.userInfo && this.props.enrollStore.userInfo.uname ? this.props.enrollStore.userInfo.uname : '';
		const currentLink = window.location.href || '';
        if (!detail.title) {
			return(
				<div>
					{this.state.hasActive?
						(<div className="Detail-init-render-result">
							<div className="title">数据加载中</div>
							<div className="message">请稍后...</div>
						</div>
					):
					(
						<div className="Detail-init-render-result">
							<img className="cen-image" src="https://cdn-xcxcustom.weiyoubot.cn/20210526/f6cf229bd87b77f3c7f0e5d6b855ea4d.png"></img>
							<div className="cen-title">活动不存在</div>
							<span className="cen-warn">被删除或被清理的活动可前往回收站查看</span>
							<div className='warn-content'>
								<div style={{display:'flex'}}>
									<div className='content-items' style={{width:'50%'}}>
									<span className='cen-label'>网络：</span>
									<span>{networkType}</span>
								</div>
									<div className='content-items' style={{width:'50%'}}>
										<span className='cen-label'>浏览器：</span>
										<span>{browserName}</span>
									</div>
								</div>
								<div className='content-items'>
									<span className='cen-label'>昵称：</span>
									<span>{userName}</span>
								</div>
								<div className='content-items'>
									<span className='cen-label'>链接：</span>
									<span className='cen-content'>{currentLink}</span>
								</div>
							</div>
							<div className='back-home-btn'>								 
								<button type="primary" style={miniBtn} onClick={()=>{
									this.props.history.push('/recycleBin')
								}}>查看回收站</button>										 				
								<button className='my-record' onClick={()=>{
									window._hmt.push(['_trackPageview',  '/manage/myEnroll'])
									this.props.history.push('/manage/myEnroll')
								}}>我的记录</button>							
							</div>							
							<div className="lottery-box" onClick={()=>{
								window.open('https://xcx.qunsou.co/recommend.html?appId=wxfaa08012777a431e');
							}}>
								<img className="lottery-banner" src={this.state.lotteryBanner} />
							</div>												
						</div>
					)
				}	
                </div>
			)
        }
				
        return (
        
            <div className="btn_bottom" style={{paddingTop: detail && detail.user_style != 2 ? '50px' : '0'}}>
                   
				{
                  	detail.user_style != 2 ? this.renderHeader(detail) : ''
                }
				{
					this.renderWxCode(detail)
				}
				<article className="detail-article">
                {
                    !this.state.isVertical ? this.renderBanner(detail) : null
                }
                {
                    !this.state.isVertical ? this.renderContent1(detail) : null
                }
				{
					this.state.isVertical ?
					<div className='vertical-screen'>
						{
							this.renderBanner(detail)
						}
						{
							this.renderContent1(detail)
						}						
					</div> : null
				}	
				{
					detail.user_style !== 2 && (
						(!detail.co_create || (detail.co_create == 1 && !detail.team_user.length))
						? this.renderOwner(detail)
						: this.renderEnrollGroup(detail)
					)
				} 					 	 				                 
				{
					this.renderMsgDialog(detail)
				}				 
				<SubmitNotice ref="submitNoticeDom" onRef={(ref)=>{ this.childNotice = ref}} detail={detail} onSuccess={()=>{
					if(!detail.team_items.fee){
						this.props.enrollStore.getItemData().then(()=>{
							this.props.enrollStore.setTeamId(null);
							var enrollStore = this.props.enrollStore;
							enrollStore.setIsteamBuy(1);
							this.setState({groupDialog:false});
							this.props.history.push('/enrollGroupForm');
						})								
					}else{
						this.setState({groupDialog:true});
					}						
				}}></SubmitNotice>
                {
                    !!detail.group_qr ? <List className="qun-view">
                        <Item
                            arrow="horizontal"
                            thumb={
                                <Badge text={1}>
                                    <img style={{width: 30, height: 30}} src={img_qun}/>
                                </Badge>
                            }
                            multipleLine
                            onClick={() => {
                                React.$wx.previewImage({
                                    current: detail.group_qr, // 当前显示图片的http链接
                                    urls: [detail.group_qr] // 需要预览的图片http链接列表
                                });
                            }}
                            extra={<Button inline={"true"} size="small">加入</Button>}
                        >
                            官方交流群 <Brief>邀请你进群参加交流讨论</Brief>
                        </Item>
                    </List> : null
                }
                {
            		this.renderFastJoin(detail)
                }
				{
					this.renderPlay()
				}
                {
                    this.renderDescribe(detail)
                }
				{
					detail.auth == 0 ? this.renderAdvert() : null
				}
				</article>
                {
                	this.renderSharePanel('none',detail)
                }
                {
                	this.renderDetailQrCode()
                }
                {
                	this.renderHomePageQrCode(detail)
                }
				{
					this.renderWxLink(detail)
				}
				{
					this.renderEnrollToken()
				}
				{
					detail.censor_status == 3 ? this.renderCensorModal(detail) : null
				}
                {
                	this.renderShareTips()
                }
				{
					this.renderGroupModal(detail)
				}         
                {
                    (detail.user_visible == 1 || detail.user_visible == 2) || detail.is_owner || detail.admin1 == 1 ?
                        <UserList eid={this.props.match.params.eid} themColor={this.state.themColor} openMsg={()=>{this.child.setDialog('open')}}/> : null
                }
				{
					this.renderNotice(detail)
				}
				{
					detail.sub_user_setting && detail.sub_user_setting.indexOf('group_enter') != -1 && (detail.admin3 == 1 || detail.is_owner) ? this.renderWxGroup(detail) : null
				}
				{
					!this.state.isWeixin && !Config.TOKEN  ? <div className="fix_bottom_weixin" onClick={() => { 
						if (this.state.isMobile && WxApi.isOtherEnvironments()){ //如果是在支付宝内 or 云闪付置浏览器中打开
							this.showMinProgram()
						}else if(this.state.isMobile){
							this.getTicket(detail)
						}else{
							this.showMinProgram()
						}
				}}></div> : null
				}
                <div className="fix_bottom">
                	<div className="share-panel" style={{flex: 3}}>
						{
							(detail.admins_node &&  detail.admins_node.length > 0) || detail.is_owner ? null :
							<a className="create btn" href={withAppBasename('/h/' + detail.owner_unionid)} onClick={() => {
								window._hmt.push(['_trackEvent', 'button_to_homepage','', '活动详情底部菜单点击主页', '']); //百度统计
							}}>
								<i className="create-icon icon-style"></i>
								<div>主页</div>
							</a>
						}                    	
	                    	<div className="share btn" onClick={() => { 
							// share=3 仅允许发起人或管理员分享，其他用户直接提示并拦截。
							if(Number(detail.share) === 3 && Number(detail.is_owner) !== 1 && Number(detail.is_admin) !== 1){
								Modal.alert('温馨提示', '发起人设置了不允许他人分享', [{ text: '我知道了' }]);
								return;
							}
							this.showSharePanel('block')							 
						}
						}>
                    		<i className="share-icon icon-style"></i>
                    		<div>分享</div>
	                    	</div>
						<div className="message-box-panel btn">
							<div className="share btn message-btn" onClick={(e) => {
									e.stopPropagation()
									if(!Config.TOKEN){
										React.$wx.webLogin()
									}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){
										this.getTicket(detail)
									}else{							
										WxApi.setMessageUserStyle(detail.user_style);
										this.props.history.push('/message')							
									}									 			
								}}>
								<div style={{position:'relative', width: '20px', margin: '0 auto'}}>
									<i className="message-icon icon-style"></i>
									{
										(detail.is_owner || (detail.admins_node &&  detail.admins_node.length > 0)) && detail.msg_count > 0 ? <span className='share-num'>{detail.msg_count > 999 ? '99+' : detail.msg_count}</span> : null
									}							
								</div>
								<div>{detail.is_owner || (detail.admins_node &&  detail.admins_node.length > 0) ? '消息' : '留言'}</div>
							</div>
						</div>						
                    	{
							detail.is_owner || (detail.admins_node &&  detail.admins_node.length > 0) ?
							<button className="create btn" onClick={()=>{
								this.setState({showManage: true})
							}}>
								<img className='manage-icon' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20230131/c996d91ae7afccb3e26b7b2f487728a1.png' />
								<div>管理</div>
							</button> : null
						}
                    </div>
					<div className='main-btn' style={{flex: 4}}>
						{
							detail.info_id ? <div className='voucher-box' onClick={()=>{
								this.setState({showVoucher: true});
							}}>
								<img className='voucher-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-10-17/f2565da0f2d843e9ab2471a7f52f5807.svg'></img>
							</div> : null
						}
						{
							this.renderGroupButton(detail)
						}	
					</div>
									
					{
						detail.is_owner || (detail.admins_node &&  detail.admins_node.length > 0) ? <ManageDialog showManage={this.state.showManage} wxJumpPath={this.wxJumpPath} openAdmin={()=>{
							this.setState({showManage: false});
							this.props.history.push('/admin?eid=' + detail.eid + '&auth=' + (detail.auth || 0) + '&status=' + (detail.status || 0) + '&temp=6&unionid=' + (detail.owner_unionid || detail.unionid || ''));
						}} openAdminRole={()=>{
							// 管理员查看自己的权限（对齐小程序 subpackage/admin/adminRole，unionid 为当前用户）
							this.setState({showManage: false});
							this.props.history.push('/adminRole?eid=' + detail.eid + '&unionid=' + (detail.unionid || ''));
						}} open={()=>{
							this.setState({showManage: false});
							this.showDetailQrCode('block');							
						}} exportData={()=>{
							// 导出数据跳转H5导出页面，需登录态
							this.setState({showManage: false});
							if(!Config.TOKEN){
								React.$wx.webLogin();
								return;
							}
							this.props.history.push('/exportData');
						}} deleteEnroll={()=>{
							// 删除活动：关闭管理面板，打开删除确认弹窗
							this.setState({showManage: false, deleteDialogShow: true});
						}} sendNotice={()=>{
							// 发送通知：关闭管理面板，跳转通知列表页（对齐小程序 /create/notice/notice）
							this.setState({showManage: false});
							if(!Config.TOKEN){
								React.$wx.webLogin();
								return;
							}
							this.props.history.push('/notice');
						}} toCheckin={()=>{
							// 核销签到：新开 H5 独立页面（对齐小程序 groupbuy/detail 跳转参数，temp 固定 6）
							this.setState({showManage: false});
							this.props.history.push('/checkin?eid=' + detail.eid
								+ '&is_owner=' + (detail.is_owner || (detail.admins_node && detail.admins_node.length > 0) ? 1 : 0)
								+ '&auth=' + (detail.auth || 0)
								+ '&rank=' + (detail.rank_switch || 0)
								+ '&temp=6');
						}} refresh={()=>{
							// 截止/开启活动成功后刷新详情，状态同步到按钮文案
							this.getDetail();
						}} close={()=>{
							this.setState({showManage: false});
						}}></ManageDialog> : null
					}			
					<VocherModal showVoucher={this.state.showVoucher} open={()=>{						
						this.setState({showVoucher: false});
						this.props.history.push('/voucher');
					}} close={()=>{
						this.setState({showVoucher: false});
					}}></VocherModal>
					<DeleteEnrollDialog show={this.state.deleteDialogShow} status={detail && detail.status} onCancel={()=>{
						this.setState({deleteDialogShow: false});
					}} onExportData={()=>{
						// 删除前先导出数据备份
						if(!Config.TOKEN){
							React.$wx.webLogin();
							return;
						}
						this.props.history.push('/exportData');
					}}></DeleteEnrollDialog>
					<SetUserInfo ref="userDom" needLogin={detail.need_login} onRef={(ref)=>{ this.userNickname = ref}}></SetUserInfo>					
                </div>
            </div>
        );
    }
}

export default App;
